import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiDropdownComponent } from './multi-dropdown.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [MultiDropdownComponent],
  exports: [MultiDropdownComponent],
  imports: [
    CommonModule,
    MultiSelectModule,
    FormsModule,
  ]
})
export class MultiDropdownModule { }
